
import '@/assets/scss/index.scss'
import CtenUnitCmp from '~/components/ug/CtenUnitCmp.vue'
import SwiperWrap from '@/components/ug/SwiperCmp.vue' // 메인 스와이프. 콘텐츠커머스용 전시구좌ID 적용
import TabCmp from '~/components/ug/TabCmp.vue' // 탭
import ProdSwiperCmp from '@/components/ug/ProdSwiperCmp.vue' // 스와이프
import { commonfunc } from '~/mixin/common'
import ContQuick from '~/components/ug/ContQuick.vue'
import CtenUnitSkeleton from '~/components/ds/skeletonUnit/CtenUnitSkeleton.vue'
import { homepageTag } from '~/utils/criteo'

export default {
  name: 'ScrUgm0001',
  components: {
    CtenUnitSkeleton,
    ContQuick,
    SwiperWrap,
    TabCmp,
    ProdSwiperCmp,
    CtenUnitCmp
  },
  mixins: [commonfunc],
  layout: 'DsMainLayout',
  data () {
    return {
      breadcrumbs: [
        {
          url: process.env.WEB_BASE_URL + '/ug/ugm/SCR_UGM_0001?thmeId=RCMD',
          text: '오늘의 발견',
        },
      ],
      banrList: [],
      swiperOpt: {
        auto: true,
        loop: false,
        navigation: true,
        pagination: 'fraction'
      },
      tabsBtnMenu: [ // 탭 메뉴
      ],
      active: '1', // 탭 index(활성화),
      tabsDataRdo: [ // 탭 data
        {
          id: '1',
          title: '10대',
          label: '1'
        },
        {
          id: '2',
          title: '20대',
          label: '2'
        },
        {
          id: '3',
          title: '30대',
          label: '3'
        },
        {
          id: '4',
          title: '40대',
          label: '4'
        },
        {
          id: '5',
          title: '50대 이상',
          label: '5'
        }
      ],
      select1: '판매 순',
      options1: [{
        value: '판매 순',
        label: '판매 순'
      }, {
        value: '택배배송',
        label: '택배배송'
      }, {
        value: '매장픽업',
        label: '매장픽업'
      }, {
        value: '대량배송',
        label: '대량배송'
      }, {
        value: '정기구매',
        label: '정기구매'
      }, {
        value: '상품권',
        label: '상품권'
      }],
      prodSwiperOpt: {
        pagination: false,
        slidesPerView: 4
      },
      hofCtenList: [],
      prodUgcSwiperOpt: {
        pagination: false,
        slidesPerView: 4,
        slidesPerGroup: 4
      },
      lgnMbMngNo: this.$store.getters['session/getMbMngNo'],
      lgnMbEid: '',
      srchForm: {
        currentPage: 1,
        pageSize: 20,
        mbMngNo: ''// 로긴한회원번호
      },
      nowSrchForm: {
        currentPage: 1,
        pageSize: 20,
        mbMngNo: ''// 로긴한회원번호
      },
      wdSrchForm: {
        currentPage: 1,
        pageSize: 20,
        mbMngNo: ''// 로긴한회원번호
      },
      rcmSrchForm: {
        currentPage: 1,
        pageSize: 20,
        mbMngNo: ''// 로긴한회원번호
      },
      rcmThmeList: [], // 추천구좌 List
      rcmThmeCtenList: [], // 추천구좌 콘텐츠List
      nowThmeCtenList: [], // NOW TAB 콘텐츠List
      wdThmeCtenList: [], // 위클리 다이소 TAB 콘텐츠List'
      observer: '',
      apiList: [
        { function: this.selHofCtenList, isRequestComplete: false }, // 에디터's PICK (1번째)
        { function: this.selMainNowThmeCtenList, isRequestComplete: false }, // Now Tab 목록조회 (2번째)
        { function: this.selMainWdCtenList, isRequestComplete: false }, // 위클리 다이소 Tab 목록조회 (3번째)
        { function: this.selMainRcmThmeCtenList, isRequestComplete: false }, // 추천구좌 목록조회 (4번째~)
      ]
    }
  },
  head () {
    return {
      title: '오늘의 발견 : 다이소몰',
      meta: [
        { hid: 'description', name: 'description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' },
        { hid: 'og:title', property: 'og:title', content: '오늘의 발견 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:site_name', property: 'og:site_name', content: '다이소몰' },
        { hid: 'og:description', property: 'og:description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' }
      ]
    }
  },
  computed: {},
  jsonld () {
    const items = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.text,
      },
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    }
  },
  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  mounted () {
    this.lgnMbMngNo = this.$store.getters['session/getMbMngNo']
    this.lgnMbEid = this.$store.getters['session/getMbEid']
    this.setObserver()
    // this.lgnMbMngNo = 'MB102023032177698123' // 'MB102023061299999991'  MB222023052577128397  MB102023051847705827
    this.selCtenBanners() // 배너목록조회
    this.selThmeTabList() // 테마탭 목록조회

    homepageTag('')
  },
  methods: {
    selHofCtenList () {
      this.srchForm.mbMngNo = this.lgnMbMngNo

      this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('ug/ugm/selMainHofCtenList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const data = res.data.data
            this.hofCtenList = data
            this.apiList[0].isRequestComplete = true
          }
        })
    },
    moveThme (thmeId) {
      this.$router.push({ path: '/ug/ugl/SCR_UGL_0001', query: { thmeId } })
    },
    getThmeDesc (thmeId) {
      const targetThme = this.tabsBtnMenu.find((item, idx) => {
        if (item.thmeId === thmeId) {
          return true
        }

        return false
      })
      return targetThme.thmeDc
    },
    moveTabPage (thmeId, tabs) { // 테마탭 눌러 페이지이동
      if (thmeId !== '') {
        this.$router.push({ path: Object.keys(tabs).length > 0 ? tabs.link : '/ug/ugm/SCR_UGM_0001', query: { thmeId } })
      }
    },
    selThmeTabList () { // 테마탭 목록 조회
      this.$AxiosBuilder
        .data()
        .build()
        .post('/ug/common/selThmeTabList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            const list = res.data.data
            this.tabsBtnMenu = list
          }
        })
    },
    selMainNowThmeCtenList () { // Now Tab 콘텐츠 목록조회
      this.nowSrchForm.mbMngNo = this.lgnMbMngNo
      this.$AxiosBuilder
        .data(this.nowSrchForm)
        .build()
        .post('/ug/ugm/selMainNowThmeCtenList')
        .then((res) => {
          this.nowThmeCtenList = res.data.data
          this.apiList[1].isRequestComplete = true
        })
    },
    selMainWdCtenList () { // 위클리 다이소 Tab 콘텐츠 목록조회
      this.wdSrchForm.mbMngNo = this.lgnMbMngNo
      this.$AxiosBuilder
        .data(this.wdSrchForm)
        .build()
        .post('/ug/ugm/selMainWdThmeCtenList')
        .then((res) => {
          this.wdThmeCtenList = res.data.data
          this.apiList[2].isRequestComplete = true
        })
    },
    selMainRcmThmeCtenList () { // 관리자 추천구좌 목록조회
      this.rcmSrchForm.mbMngNo = this.lgnMbMngNo
      this.$AxiosBuilder
        .data(this.rcmSrchForm)
        .build()
        .post('/ug/ugm/selMainRcmThmeCtenList')
        .then((res) => {
          // Main 추천구좌 List
          this.rcmThmeList = res.data.data.rcmThmeList
          console.log('selMainRcmThmeCtenList Start')
          console.log('rcmThmeList : ', this.rcmThmeList)
          // Main 추천구좌 콘텐츠 List
          this.rcmThmeCtenList = res.data.data.rcmThmeCtenList
          console.log('rcmThmeCtenList : ', this.rcmThmeCtenList)
          this.apiList[3].isRequestComplete = true
        })
    },
    selCtenBanners () {
      this.$AxiosBuilder
        .data({ exhCmptmtId: '2023102603', exhMtrlNo: '1' }) // STG용 2023102603 전시구좌ID, 소재ID / dev용 2023110601
        .build()
        .post('/ds/exh/selBanr')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            this.banrList = res.data.data.details
          }
        })
    },
    setObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            const id = entry.target.id
            const tagId = id.match(/\d+/)[0]

            if (!this.apiList[tagId].isRequestComplete) {
              this.apiList[tagId].function() // api 호출하기
            }
          }
        })
      }, options)

      const slotList = document.querySelectorAll('[id*="slot"]')
      slotList.forEach((el) => {
        this.observer.observe(el)
      })
    },
  }
}
